<template>
  <v-container class="no-print" fluid grid-list-lg>
    <ReceivePayment
      :CustomerId="selectedInvoice ? selectedInvoice.CustomerId : null"
      :createDialog="receivePaymentDialog"
      @close="receivePaymentDialog = false"
      @submit="getList()"
      :invoice="selectedInvoice"
      :invoiceReceivePayment="true"
    ></ReceivePayment>
    <v-card :loading="loading" outlined>
      <v-toolbar dense flat :color="$style.purchase.titlebar">
        <v-app-bar-nav-icon v-if="!CustomerId" @click="$router.go(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>

        <v-toolbar-title> Invoice List </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-layout row wrap justify-end class="mb-1">
          <v-flex shrink>
            <v-btn
              @click="add"
              outlined
              rounded
              :icon="$vuetify.breakpoint.xsOnly"
              v-if="checkRightStatus(6)"
              raised
              small
            >
              <v-icon small>add</v-icon>
              <span v-if="!$vuetify.breakpoint.xsOnly">New</span>
            </v-btn>
          </v-flex>
          <v-flex shrink v-if="InvoiceDetails.length !== 0">
            <v-btn
              @click="openRunning"
              outlined
              :icon="$vuetify.breakpoint.xsOnly"
              class="ml-2"
              rounded
              v-if="checkRightStatus(6)"
              raised
              small
            >
              <v-icon small>mdi-history</v-icon>
              <span v-if="!$vuetify.breakpoint.xsOnly">Running Invoice</span>
            </v-btn>
          </v-flex>
          <v-flex shrink v-if="!$vuetify.breakpoint.xsOnly">
            <v-checkbox
              v-model="showDueInvoice"
              label="Show Due Invoices"
            ></v-checkbox>
          </v-flex>
        </v-layout>
      </v-toolbar>

      <v-toolbar dense elevation="0" v-if="$vuetify.breakpoint.mdAndUp">
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="search"
          autofocus
          dense
          label="Search"
          single-line
          style="min-width: 250px"
          hide-details
          clearable
        ></v-text-field>
        <v-divider vertical class="mx-1"></v-divider>
        <v-btn-toggle v-model="invoiceStatus" @change="getList()" small group>
          <v-btn value="all">
            <span>All</span>
          </v-btn>

          <v-btn value="open">
            <span>Open</span>
          </v-btn>

          <v-btn value="paid">
            <span>Paid</span>
          </v-btn>
        </v-btn-toggle>
        <v-spacer></v-spacer>

        <!-- <DateTimePicker :defaultRange="currentBusiness?.metadata?.invoiceViewLimit?.range || 'since15DaysAgo'"
          :range="true" :hideTime="true" v-model="dateTime" @submit="getList()" /> -->
        <!-- hasInvoiceViewLimit: {{ hasInvoiceViewLimit }} -->
        <DateTimePicker
          :defaultRange="defaultRange"
          :range="true"
          :hideTime="true"
          v-model="dateTime"
          @submit="getList()"
        />

        <!-- <DateTimePicker :defaultRange="currentBusiness?.metadata?.invoiceViewLimit?.range || 'since15DaysAgo'"
          :range="true" :hideTime="true" v-model="dateTime" @submit="getList()" /> -->
      </v-toolbar>

      <v-toolbar v-else dense flat elevation="0">
        <v-btn
          v-if="$vuetify.breakpoint.smAndDown"
          icon
          class="filter-toolbar__mobile-trigger"
          @click="mobileFilterSheet = true"
        >
          <v-icon>mdi-tune-variant</v-icon>
        </v-btn>
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="search"
          autofocus
          dense
          label="Search"
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-toolbar>

      <v-divider></v-divider>

      <v-bottom-sheet
        v-show="$vuetify.breakpoint.smAndDown"
        v-model="mobileFilterSheet"
        inset
        max-width="520"
      >
        <v-card>
          <v-toolbar dense flat elevation="0">
            <v-btn icon @click="mobileFilterSheet = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <span class="subtitle-2">Filters</span>
          </v-toolbar>
          <v-card-text>
            <v-btn-toggle
              v-model="invoiceStatus"
              @change="getList()"
              color="deep-purple accent-3"
              group
              class="mobile-status-toggle"
            >
              <v-btn value="all">All</v-btn>
              <v-btn value="open">Open</v-btn>
              <v-btn value="paid">Paid</v-btn>
            </v-btn-toggle>
            <v-divider class="my-2"></v-divider>
            <DateTimePicker
              :defaultRange="defaultRange"
              :range="true"
              :hideTime="true"
              v-model="dateTime"
              @submit="getList()"
            />
            <v-checkbox
              v-model="showDueInvoice"
              label="Show Due Invoices"
            ></v-checkbox>
            <v-btn
              block
              color="primary"
              text
              class="mt-2"
              @click="mobileFilterSheet = false"
            >
              Close
            </v-btn>
          </v-card-text>
        </v-card>
      </v-bottom-sheet>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="Invoices"
          :loading="loading"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :page.sync="page"
          :items-per-page.sync="itemsPerPage"
          :server-items-length="totalItems"
          @current-items="updateTotal"
          :footer-props="{ 'items-per-page-options': [10, 15, 25, 50, 100] }"
        >
          <template v-slot:item="{ item }">
            <tr class="pointer">
              <td class="text-left" @click="viewInvoice(item)">
                <span>{{ item.date | moment("L LT") }}</span>
                <!-- <v-tooltip v-if="showUpdatedDot(item)"  bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="ml-2">
                      <span class="updated-dot"></span>
                    </span>
                  </template>
                  <span>
                    This invoice was updated on
                    {{ formatUpdatedAt(item.updatedAt) }} after the day it was
                    created.
                  </span>
                </v-tooltip> -->
              </td>
              <td class="text-left" @click="viewInvoice(item)">
                <span class="pr-1">{{ item.localId }}</span>
                <v-chip
                  color="red lighten-3"
                  label
                  small
                  v-if="item.due === 0"
                  text-color="red darken-4"
                  >Paid</v-chip
                >

                <div
                  v-if="
                    currentBusiness && currentBusiness.metadata &&
                    !currentBusiness.metadata.isSingleCustomerPricing &&
                    item.PriceTier
                  "
                >
                  <v-chip
                    small
                    class="font-weight-bold"
                    color="red"
                    text-color="white"
                    >{{ item.PriceTier.name }}</v-chip
                  >
                </div>
              </td>
              <td
                class="text-left"
                v-if="!CustomerId"
                @click="viewInvoice(item)"
              >
                <div>{{ item.Customer.name }}</div>
                <div
                  v-if="
                    currentBusiness &&
                    currentBusiness.metadata &&
                    currentBusiness.metadata.showDueDateOnInvoice &&
                    item.dueDate
                  "
                  class="caption"
                >
                  Due:
                  <span :class="dueDateColor(item.dueDate)">{{
                    item.dueDate | moment("from", "now")
                  }}</span>
                </div>
              </td>
              <!-- <td class="text-left" @click="viewInvoice(item)">
                
              </td> -->
              <td class="text-right" @click="viewInvoice(item)">
                {{ item.total | currency }}
              </td>
              <td class="text-right" @click="viewInvoice(item)">
                {{ item.payment | currency }}
              </td>
              <td class="text-right" @click="viewInvoice(item)">
                {{ item.due | currency }}
              </td>
              <td class="justify-end align-center text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="menu-button">
                    <v-list-item @click="viewInvoice(item)">
                      <v-list-item-title>View Invoice</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="viewPackingSlip(item)">
                      <v-list-item-title>View Packing Slip</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="item.due !== 0"
                      @click="receivePayment(item)"
                    >
                      <v-list-item-title>Receive Payment</v-list-item-title>
                    </v-list-item>
                    <v-divider v-if="!CustomerId"></v-divider>
                    <v-list-item v-if="!CustomerId" @click="viewProfile(item)">
                      <v-list-item-title>Profile</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item @click="copyInvoice(item)">
                      <v-list-item-title>Copy Invoice</v-list-item-title>
                    </v-list-item>
                    <!-- v-if="item.due !== 0" -->
                    <v-list-item @click="editInvoice(item)">
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="deleteInvoice(item)">
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                    <ShareLink
                      :id="item.id"
                      :postfix="`view?key=${currentBusiness.code}`"
                      type="invoice"
                      :text="`Invoice from ${currentBusiness.name} click the link to view`"
                    />
                    <v-divider></v-divider>
                    <v-list-item @click="openSignature(item)">
                      <v-list-item-title>Receive Signature</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item @click="openHistory(item)">
                      <v-list-item-title>View History</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning"
            >Your search for "{{ search }}" found no results.</v-alert
          >

          <template v-slot:body.append="{ headers }">
            <tr :style="{ 'background-color': $style.listTotal.filter }">
              <td
                :colspan="headers.length - 4"
                class="text-right font-weight-bold"
              >
                List Total
              </td>
              <td class="text-right font-weight-bold">
                {{ listTotal | currency }}
              </td>
              <td class="text-right font-weight-bold">
                {{ listPayment | currency }}
              </td>
              <td class="text-right font-weight-bold">
                {{ listBalance | currency }}
              </td>
              <td></td>
            </tr>
            <tr :style="{ 'background-color': $style.listTotal.result }">
              <td
                :colspan="headers.length - 4"
                class="text-right font-weight-bold"
              >
                Result Total
              </td>
              <td class="text-right font-weight-bold">
                {{ fullTotal | currency }}
              </td>
              <td class="text-right font-weight-bold">
                {{ fullPayment | currency }}
              </td>
              <td class="text-right font-weight-bold">
                {{ fullBalance | currency }}
              </td>
              <td></td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <InvoiceHistoryDialog
      v-show="historyDialog"
      v-model="historyDialog"
      :invoice="historyInvoice"
    />

    <SignaturePadDialog
      v-model="signatureDialog"
      :invoice="selectedInvoice"
      @save-signature="saveSignature"
    />

    <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-container>
          <div class="mb-3">Please stand by deleting purchase</div>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import invoiceService from "../service";
import ShareLink from "@/components/ShareLink";
const DateTimePicker = () => import("@/components/DateTimePicker");
import InvoiceReceipt from "@/modules/Invoice/components/InvoiceReceipt.vue";
import InvoiceHistoryDialog from "@/modules/Invoice/components/InvoiceHistoryDialog.vue";
import Hashids from "hashids";
import SignaturePadDialog from "@/components/SignaturePad.vue";
const hashids = new Hashids();
import _ from "lodash";

const ReceivePayment = () =>
  import("@/modules/Customer/Payment/components/Create.vue");

export default {
  props: {
    CustomerId: {
      default: null,
    },
    showAll: {
      default: false,
    },
    due: {
      default: false,
    },
  },
  name: "invoice-list",
  data() {
    return {
      historyDialog: false,
      historyInvoice: null,
      mobileFilterSheet: false,
      totalItems: 0,
      invoiceStatus: "all",
      loadingDialog: false,
      showDueInvoice: false,
      fullTotal: 0,
      fullPayment: 0,
      fullBalance: 0,
      listTotal: 0,
      listPayment: 0,
      listBalance: 0,
      fab: false,
      dateTime: {
        start: this.$moment()
          .startOf("days")
          .subtract(60, "days")
          .toISOString(),
        end: this.$moment().endOf("day").toISOString(),
      },
      createDialog: false,
      selectedPayee: null,
      headers: [],
      Invoices: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "localId",
      pageCount: 0,
      sortDesc: true,
      itemsPerPage: 10,
      receivePaymentDialog: false,
      selectedInvoice: null,
      signatureDialog: false,
    };
  },
  watch: {
    search: _.debounce(function () {
      this.page = 1;
      this.getList();
    }, 300),
    page() {
      this.getList();
    },
    itemsPerPage() {
      this.page = 1;
      this.getList();
    },
    sortBy() {
      this.page = 1;
      this.getList();
    },
    sortDesc() {
      this.page = 1;
      this.getList();
    },
    CustomerId: {
      immediate: true,
      handler() {
        this.getList();
      },
    },
    showDueInvoice() {
      this.getList();
    },
  },
  created() {
    this.loadHeader();
    this.$events.listen("invoiceListEvent", () => this.getList());
    // document.title = "smplsale - Invoice List";
  },
  beforeDestroy() {
    this.$events.remove("invoiceListEvent");
  },
  components: {
    DateTimePicker,
    ShareLink,
    ReceivePayment,
    InvoiceReceipt,
    InvoiceHistoryDialog,
    SignaturePadDialog,
  },
  computed: {
    ...mapGetters("global", [
      "currentUser",
      "checkRightStatus",
      "currentBusiness",
    ]),
    ...mapGetters("invoice", ["InvoiceDetails", "getEditInvoiceId"]),
    hasInvoiceViewLimit() {
      if (this.currentBusiness.metadata) {
        return (
          this.currentBusiness &&
          this.currentBusiness.metadata &&
          this.currentBusiness.metadata.invoiceViewLimit
        );
      } else {
        return true;
      }
    },
    defaultRange() {
      if (
        this.currentBusiness.metadata &&
        this.currentBusiness.metadata.invoiceViewLimit
      ) {
        return this.currentBusiness.metadata.invoiceViewLimit.range;
        // return this.hasInvoiceViewLimit ? this.currentBusiness.metadata.invoiceViewLimit.range : 'since15DaysAgo';
      } else {
        return "since60DaysAgo";
      }
    },
  },
  methods: {
    ...mapActions("invoice", ["ResetInvoice"]),
    showUpdatedDot(item) {
      if (!item || !item.createdAt || !item.updatedAt) return false;

      const created = this.$moment(item.createdAt).startOf("day");
      const updated = this.$moment(item.updatedAt).startOf("day");

      // Only show if they are on different days
      return !created.isSame(updated);
    },

    formatUpdatedAt(val) {
      if (!val) return "";
      return this.$moment(val).format("L LT");
    },
    openSignature(invoice) {
      this.selectedInvoice = invoice;
      this.signatureDialog = true;
    },
    openHistory(invoice) {
      if (!this.currentBusiness.metadata.historyTracking) {
        this.$swal({
          icon: "warning",
          title: "History Tracking Off",
          text: "Enable it in Settings to view change logs ($50/month).",
        });
        return;
      }
      this.historyInvoice = invoice;
      this.historyDialog = true;
    },
    async saveSignature({ invoiceId, payload }) {
      try {
        await invoiceService.updateMetadata(invoiceId, {
          deliverySignature: payload,
        });

        this.$swal("Success", "Signature saved to invoice.", "success");
        this.getList();
      } catch (err) {
        console.error(err);
        this.$swal(
          "Error",
          err.data?.message || "Could not save signature.",
          "error"
        );
      }
    },
    dueDateColor(val) {
      const dueDate = val ? this.$moment(val) : this.$moment();
      const today = this.$moment().startOf("day");

      return dueDate.isBefore(today)
        ? "red--text font-weight-bold"
        : "black--text"; // Adjust color classes as needed
    },
    updateTotal(val) {
      this.total = 0;
      this.payment = 0;
      this.balance = 0;
      val.map((row) => {
        this.total += row.total;
        this.payment += row.payment;
        this.balance += row.due;
      });
    },
    copyInvoice(item) {
      invoiceService
        .getById(item.id)
        .then((obj) => {
          const passData = obj.data;
          passData.CustomerId = null;

          this.$router.push({
            name: "invoice-create",
            params: { passData: passData, type: "invoice" },
          });
        })
        .catch((err) => {
          // console.log("got error", err);
        });
    },
    receivePayment(row) {
      this.receivePaymentDialog = !this.receivePaymentDialog;
      this.selectedInvoice = row;
    },
    openRunning() {
      if (this.getEditInvoiceId) {
        this.$router.push({ path: `/invoice/${this.getEditInvoiceId}/edit` });
      } else {
        this.$router.push({ path: `/invoice/create` });
      }
    },
    viewOpenInvoice() {
      const hashId = hashids.encode(this.CustomerId);
      const routeData = this.$router.resolve({
        path: `/global/invoice/${hashId}/openInvoice`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    add() {
      if (this.InvoiceDetails.length !== 0) {
        this.$swal({
          title: "Are you sure?",
          text: "There is an running invoice you want to clear it",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            this.ResetInvoice();
            if (this.CustomerId) {
              this.$router.push({
                path: `/invoice/create?CustomerId=${this.CustomerId}`,
              });
            } else {
              this.$router.push({ path: `/invoice/create` });
            }
          }
        });
      } else {
        if (this.CustomerId) {
          this.$router.push({
            path: `/invoice/create?CustomerId=${this.CustomerId}`,
          });
        } else {
          this.$router.push({ path: `/invoice/create` });
        }
      }
    },
    viewProfile(val) {
      this.$router.push({ path: `/customer/${val.CustomerId}/profile` });
    },
    viewInvoice(invoice) {
      const hashId = hashids.encode(invoice.id);
      let createdLink = `/global/invoice/${hashId}/view`;
      console.log("createdLink", createdLink);
      const routeData = this.$router.resolve({
        path: createdLink,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    viewPackingSlip(invoice) {
      const hashId = hashids.encode(invoice.id);
      const routeData = this.$router.resolve({
        path: `/global/invoice/${hashId}/packingSlip`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    loadHeader() {
      this.headers = [];
      this.headers.push({
        text: this.$t("labels.date"),
        align: "left",
        value: "date",
        sortable: true,
      });

      this.headers.push({
        text: "Invoice Number",
        align: "left",
        value: "localId",
        sortable: true,
      });

      if (!this.CustomerId) {
        this.headers.push({
          text: "Customer Name",
          value: "Customer.name",
          align: "left",
          sortable: true,
        });
      }

      // this.headers.push({
      //   text: "Due Date",
      //   value: "dueDate",
      //   align: "left",
      //   sortable: true,
      // });

      // this.headers.push({
      //   text: "Note",
      //   align: "left",
      //   value: "note",
      //   sortable: true
      // });

      this.headers.push({
        text: "Total",
        value: "total",
        align: "right",
        sortable: true,
      });

      this.headers.push({
        text: "Payment",
        value: "payment",
        align: "right",
        sortable: true,
      });

      this.headers.push({
        text: "Balance",
        value: "due",
        align: "right",
        sortable: true,
      });
      this.headers.push({
        text: "",
        value: "action",
        sortable: false,
      });
    },
    getList() {
      this.loading = true;

      // Base where
      let where = {};
      if (!this.showAll) {
        where.start = this.dateTime.start;
        where.end = this.dateTime.end;
      }

      // Status chips
      if (this.invoiceStatus === "open") where.due = true;
      if (this.invoiceStatus === "paid") where.paid = true;
      if (this.invoiceStatus === "all") {
        delete where.paid;
        delete where.due;
      }

      // Permissions / filters
      if (!this.currentUser.isAdmin && this.checkRightStatus(50)) {
        where.assingedCustomer = this.currentUser.id;
      }
      if (this.CustomerId) where.CustomerId = this.CustomerId;
      if (this.due) where.due = true;
      where.showDueInvoice = this.showDueInvoice;

      // Normalize Vuetify sort (can be arrays)
      const sb = Array.isArray(this.sortBy) ? this.sortBy[0] : this.sortBy;
      const sd = Array.isArray(this.sortDesc)
        ? this.sortDesc[0]
        : this.sortDesc;
      const sortBy = sb || "localId";
      const sortDesc = !!sd;

      // Server-side paging + sorting + search
      const query = {
        ...where,
        search: this.search || "",
        limit: this.itemsPerPage,
        offset: (this.page - 1) * this.itemsPerPage,
        sortBy,
        sortDesc,
        // back-compat if your BE still reads orderBy:
        orderBy: [sortBy, String(sortDesc)],
      };

      return invoiceService
        .getAll(query)
        .then((response) => {
          console.log("invoice response", response);
          this.loading = false;
          // Expecting: { count: <number>, data: <array> }
          const res = response; // your API returns the object directly
          const rows = res.data || [];
          const cnt = Number(res.count) || 0;
          this.totalItems = cnt;
          this.Invoices = rows;

          // Recompute full totals across *page* rows (your footer sums current page).
          this.listTotal = 0;
          this.listPayment = 0;
          this.listBalance = 0;

          this.fullTotal = response?.totals?.total || 0;
          this.fullPayment = response?.totals?.payment || 0;
          this.fullBalance = this.fullTotal - this.fullPayment;

          this.Invoices.forEach((row) => {
            this.listTotal += row.total;
            this.listPayment += row.payment;
            this.listBalance += row.due;
          });

          return response;
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },
    editInvoice(invoice) {
      // console.log('ddf', invoice)
      this.$router.push({ path: `/invoice/${invoice.id}/edit` });
    },
    deleteInvoice(invoice) {
      if (
        this.currentBusiness.metadata &&
        this.currentBusiness.metadata.deletePrecaution
      ) {
        this.$swal
          .fire({
            title: "Are you sure?",
            html: `You won't be able to revert this.</br> <div style="color:red;">Type <span style="font-weight: bold">delete</span> in order remove this</div>`,
            icon: "question",
            input: "text",
            inputAttributes: {
              autocapitalize: "off",
            },
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Delete",
          })
          .then((result) => {
            if (result.value && result.value === "delete") {
              this.loadingDialog = true;
              invoiceService
                .delete(invoice.id)
                .then((response) => {
                  // console.log("response delete", response);
                  this.loadingDialog = false;
                  if (response.data) {
                    this.$swal
                      .mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 3000,
                      })
                      .fire({
                        icon: "success",
                        title: "Invoice has been deleted.",
                      });
                    // this.$swal("Deleted!", "Invoice has been deleted.", "success");
                    this.getList();
                    this.$events.emit("customerProfileEvent");
                    this.$events.emit("CustomerMiniList");
                  }
                })
                .catch((error) => {
                  this.loadingDialog = false;
                  this.$swal({
                    title: "Delete Invoice",
                    text: error.data.message,
                    type: "error",
                  });
                });
            } else if (result.dismiss === "cancel") {
            } else {
              this.$swal("Delete", 'Type "delete" to delete item', "error");
            }
          });
      } else {
        this.$swal({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            this.loadingDialog = true;
            invoiceService
              .delete(invoice.id)
              .then((response) => {
                // console.log("response delete", response);
                this.loadingDialog = false;
                if (response.data) {
                  this.$swal
                    .mixin({
                      toast: true,
                      position: "top-end",
                      showConfirmButton: false,
                      timer: 3000,
                    })
                    .fire({
                      icon: "success",
                      title: "Invoice has been deleted.",
                    });
                  // this.$swal("Deleted!", "Invoice has been deleted.", "success");
                  this.getList();
                  this.$events.emit("customerProfileEvent");
                  this.$events.emit("CustomerMiniList");
                }
              })
              .catch((error) => {
                this.loadingDialog = false;
                this.$swal({
                  title: "Delete Invoice",
                  text: error.data.message,
                  type: "error",
                });
              });
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.updated-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #f44336;
  box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.7);
  animation: updated-dot-pulse 1.5s infinite;
}

@keyframes updated-dot-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.7);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(244, 67, 54, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
  }
}
</style>